export const SQ_SID_COOKIE_NAME = "sq_sid";

export const DEFAULT_OFFLINE_ATTRIBUTED_SOURCE = "Sales";

export const ENRICHED_PROPERTY_THRESHOLD = Number.parseInt(
	process.env.ENRICHED_PROPERTY_THRESHOLD ?? "3",
	10,
);

export function isIdentityGraphClientEnabled(): boolean {
	const raw =
		process.env.NEXT_PUBLIC_IDENTITY_GRAPH_CLIENT_ENABLED ??
		process.env.IDENTITY_GRAPH_CLIENT_ENABLED ??
		"true";
	return raw.trim().toLowerCase() !== "false";
}
